<div class="container-content container-advanceSearch">
    <h1>Advanced Search</h1>
    <form #searchForm="ngForm" novalidate class="form-advanceSearch" (submit)="doSearch(searchForm, $event)" autocomplete="off">
        <fieldset class="container-queryInput">
            <div class="input-group">
                <input type="text"
                       [placeholder]="'Search ' + productName"
                       class="form-control"
                       name="query"
                       [matAutocomplete]="auto"
                       [formControl]="ctrl"
                       [attr.aria-label]="'Search ' + productName"
                       [value]="term">
                <div class="input-group-btn">
                    <button type="submit" aria-label="search button" class="btn btn-default">
                        <svg class="gr-search" xmlns="http://www.w3.org/2000/svg">
                            <use xlink:href="./assets/img/icons.svg#gr-search"></use>
                        </svg>
                    </button>
                </div>
            </div>
        </fieldset>

        <div class="sr-only" aria-live="polite">{{ariaMessageTxt}}</div>
        <mat-autocomplete #auto="matAutocomplete" (opened)="handleAutoCompleteOpened()" (closed)="handleAutoCompleteClosed()" >
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            {{ option }}
          </mat-option>
        </mat-autocomplete>

        <section class="container-advanceSearchOptions">
            <div class="col" *ngIf="suppressSourceTypes !== true">
                <fieldset class="container-sourceTypes">
                    <legend>Source Type</legend>
                    <ul>
                        <li *ngFor="let source of sourceTypes">
                          <label class="material-radio">
                            <input (click)="handleSourceTypeSelection(source.label)" type="radio" name="source" [value]="source.label.toLowerCase()" [ngModel]="currentSourceType">
                            <span class="outer">
                              <span class="inner"></span>
                            </span>
                            <svg [ngClass]="source.icon" xmlns="http://www.w3.org/2000/svg" *ngIf="source.key.toLowerCase() !== 'all'">
                              <use [attr.xlink:href]="'./assets/img/icons.svg#' + source.icon"></use>
                            </svg>
                            {{source.label}}
                          </label>
                        </li>
                    </ul>
                </fieldset>

                <fieldset class="container-sourceTypes">
                    <div class="checkbox styled-checkbox">
                        <input (click)="handleCurrencyFilterSelection($event.target.checked, 'currency')" type="checkbox" [id]="'currency'" [value]="'currency'" [checked]="false" name="currency" [ngModel]="currencyFilter">
                        <label [attr.for]="'currency'">
                            Exclude older newspapers and magazines
                            <svg class="gr-info-circled" role="button" aria-label="more information" tabindex="0" xmlns="http://www.w3.org/2000/svg" [matTooltip]="iseLibrary ? 'With this box checked, newspaper and magazine articles published more than two years ago will not appear in your results.' : 'With this box checked, newspaper and magazine articles published more than ten years ago will not appear in your results.' ">
                             <use xlink:href="./assets/img/icons.svg#gr-info-circle"></use>
                            </svg>
                        </label>
                    </div>
                </fieldset>
            </div>

            <div class="col">
                <fieldset class="container-pubdate">
                    <legend>Publication Date</legend>
                    <div class="form-group select-wrapper form-control">
                        <label for="pubdateRange" class="sr-only">Publication Date</label>
                        <select id="pubdateRange" (change)="onDateRangeChange($event)" ngModel="all" name="pubdateRange">
                            <option value="all">All dates</option>
                            <option value="30 days">Last 30  days</option>
                            <option value="12 months">Last 12 months</option>
                            <option value="custom">Custom</option>
                        </select>
                    </div>

                    <div class="container-pubdateRange">
                        <p *ngIf="dateRangeError" class="error" role="alert">{{dateRangeError}}</p>
                        <div *ngIf="showDateRange">
                            <div class="container-date">
                                <pq-datepicker
                                  [date]="dateRangeModel.fromDate"
                                  dateFormat="MM/DD/YYYY" placeholder="mm/dd/yyyy"
                                  inputLabel="From"
                                  dateType="starting"
                                  inputName="pubFromDate"
                                  (onChange)="onSelectFrom($event)"
                                  (focus)="onSelectFrom($event)">
                                </pq-datepicker>
                            </div>

                            <div class="container-date">
                                <pq-datepicker
                                  [date]="dateRangeModel.toDate"
                                  dateFormat="MM/DD/YYYY"
                                  placeholder="mm/dd/yyyy"
                                  inputLabel="To"
                                  dateType="ending"
                                  inputName="pubToDate"
                                  [rangeStart]="dateRangeModel.fromDate"
                                  (onChange)="onSelectTo($event)"
                                  (focus)="onSelectTo($event)">
                                </pq-datepicker>
                            </div>
                        </div>
                    </div>

                </fieldset>

                <fieldset *ngIf="suppressSimpleLimiters !== true">
                    <legend>Limit To</legend>
                    <ul>
                        <li *ngFor="let filter of limitToFilter; let i = index">
                          <div class="checkbox styled-checkbox">
                            <input (click)="handleSearchLimitSelection($event.target.checked, filter.label)" type="checkbox" [id]="'limitTo' + i" [value]="filter.value" [checked]="filter.selected === 'Y'" [name]="filter.name" ngModel>
                            <label [for]="'limitTo' + i">{{filter.label}}</label>
                          </div>
                        </li>
                    </ul>
                </fieldset>
            </div>

            <div class="col">
                <fieldset class="container-lexileScore" *ngIf="suppressLexileScores !== true">
                    <legend>Lexile Score</legend>
                    <p *ngIf="lexileScoreRangeError" class="error" role="alert" [innerHTML]="lexileScoreRangeError"></p>
                    <div>
                        <div class="form-group">
                            <label for="lexileMin" class="sr-only">Lexile Score Minimum</label>
                            <input type="text" value="" id="lexileMin" class="form-control" maxlength="5" name="lexilemin" ngModel lexileNumber>
                        </div>

                        <span>to</span>

                        <div class="form-group">
                            <label for="lexileMax" class="sr-only">Lexile Score Maximum</label>
                            <input type="text" value="" id="lexileMax" class="form-control" maxlength="5" name="lexilemax" ngModel lexileNumber>
                        </div>
                    </div>
                </fieldset>
            </div>
        </section>

        <div class="container-actions">
            <button type="submit" class="btn btn-default">Search</button>
        </div>
    </form>
</div>
